import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    addBureauRequest: ['response'],
    addBureauSuccess: ['response', 'loading'],
    addBureauFailure: ['error'],
})

export const addBureauTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    success: null,
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const addBureauRequest = state => state.merge({ loading: true })

const addBureauSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
        loading: false,
    })

const addBureauFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        loading: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.ADD_BUREAU_REQUEST]: addBureauRequest,
    [Types.ADD_BUREAU_SUCCESS]: addBureauSuccess,
    [Types.ADD_BUREAU_FAILURE]: addBureauFailure,
})
